import { actions } from "./Reducer";
/**
 * Actions that fire saga watchers
 */

// Singular
export const createSupplierJobAction = (formData) => ({
  type: actions.CREATE_JSUPPLIER,
  payload: formData,
});

export const createSingleSupplierJobAction = (formData) => ({
  type: actions.GET_SINGLE_JSUPPLIER,
  payload: formData,
});

export const updateSupplierJobAction = (id, formData) => ({
  type: actions.UPDATE_JSUPPLIER,
  payload: {
    id,
    formData,
  },
});

export const updateSupplierApplicantStatusAction = (formData) => ({
  type: actions.UPDATE_JSUPPLIER_APPLICANT_STATUS,
  payload: formData,
});
// Plural
export const getSupplierJobsAction = (body) => ({
  type: actions.GET_JSUPPLIER,
  payload : body
});

export const getSupplierJobsPendingAction = (body) => ({
  type: actions.GET_JSUPPLIER_PENDING,
  payload : body
});

/**
 * Actions that are fired by redux-saga watchers
 */

// Singular
export const createSupplierJobSuccessAction = (job) => ({
  type: actions.CREATE_JSUPPLIER_SUCCESS,
  payload: job,
});

export const updateSupplierApplicantStatusSuccessAction = (job) => ({
  type: actions.UPDATE_JSUPPLIER_APPLICANT_STATUS_SUCCESS,
  payload: job,
});

export const updateSupplierJobSuccessAction = (job) => ({
  type: actions.UPDATE_JSUPPLIER_SUCCESS,
  payload: job,
});
// Plural
export const getSupplierJobsSuccessAction = (SupplierJobs) => ({
  type: actions.GET_JSUPPLIER_SUCCESS,
  payload: SupplierJobs,
});
export const getSingleSupplierJobSuccessAction = (SupplierJob) => ({
  type: actions.GET_SINGLE_JSUPPLIER_SUCCESS,
  payload: SupplierJob,
});

export const getSupplierJobsPendingSuccessAction = (SupplierJobs) => ({
  type: actions.GET_JSUPPLIER_PENDING_SUCCESS,
  payload: SupplierJobs,
});

export const deleteJobAction = (id) => ({
  type: actions.DELETE_JSUPPLIER,
  payload: id,
});

export const deleteJobSuccessAction = (jobId) => ({
  type: actions.DELETE_JSUPPLIER_SUCCESS,
  payload: jobId,
});


/**
 * Misc
 */
export const setSupplierJobsIsLoadingAction = (isLoading) => ({
  type: actions.SET_JSUPPLIER_IS_LOADING,
  payload: isLoading,
});

export const setSupplierJobsCountAction = (count) => ({
  type: actions.SET_JSUPPLIER_COUNT,
  payload: count,
});

export const setSearchValueAction = value => ({
  type : actions.SET_AT_SEARCH_VALUE,
  payload : value
})